import { UPDATE_RANDD } from "../constants";

const initialState = null;

export const setRandDData = (data) => ({
    type: UPDATE_RANDD,
    data,
});

export const randD = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_RANDD:
            return action.data;
        default:
            return state;
    }
};